import { render, staticRenderFns } from "./LogComponent.vue?vue&type=template&id=d3fd0b52"
import script from "./LogComponent.vue?vue&type=script&lang=js"
export * from "./LogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports